import { render, staticRenderFns } from "./LimpiarPaquetes.vue?vue&type=template&id=66953ffc&scoped=true"
import script from "./LimpiarPaquetes.vue?vue&type=script&lang=js"
export * from "./LimpiarPaquetes.vue?vue&type=script&lang=js"
import style0 from "./LimpiarPaquetes.vue?vue&type=style&index=0&id=66953ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66953ffc",
  null
  
)

export default component.exports